const NAMESPACE = "projectLockedBanner";

const KEYS = {
    projectLockedHeader: "projectLockedHeader",
    paymentUnderway: "paymentUnderway",
    tableImportUnderway: "tableImportUnderway"
};

const MESSAGES = {
    [KEYS.projectLockedHeader]: {
        value: "Project Locked - {lockReason}",
        comment: "Title for the project locked banner"
    },
    [KEYS.paymentUnderway]: {
        value: "Payment Process Underway",
        comment: "Header message when processing a payment"
    },
    [KEYS.tableImportUnderway]: {
        value: "Project Table Import Underway",
        comment: "Header message when importing to a project table"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
